<template>
    <div class="recognition-card">
        <template v-if="card">
            <div
                v-if="card.description"
                class="recognition-card__back">
                <p v-html="card.description"></p>
            </div>
            <!-- front -->
            <div
                v-if="card.image"
                class="recognition-card__front"
                :class="{ opacity_animation: card.description }">
                <img
                    alt=""
                    class="max-lg:tw-hidden"
                    :src="useMedia(card.image).medium" />
                <img
                    alt=""
                    class="lg:tw-hidden"
                    :src="useMedia(card.imageMobile ? card.imageMobile : card.image).medium" />
                <p
                    v-if="card.title"
                    v-html="card.title"></p>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
    import { useMedia } from '@/composables/useMedia';

    const props = defineProps<{
        card: {
            description: string;
            image: string;
            title: string;
            imageMobile: string;
        };
    }>();
</script>

<style scoped lang="scss">
    .recognition-card {
        @apply tw-relative tw-overflow-hidden tw-rounded-4xl tw-bg-blue-35 tw-shadow-md;
    }

    .recognition-card__back {
        @apply tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-p-6 tw-text-sm;
        border-radius: inherit;
        z-index: 2;

        > * {
            position: relative;
            z-index: 2;
        }

        &::before {
            content: '';
            @apply tw-absolute tw-inset-0 tw-z-[0] tw-bg-white;
        }
        &::after {
            content: '';
            @apply tw-absolute tw-inset-0 tw-z-[1];
            background: url('@/assets/gradients/gradient-recognition.png') no-repeat center center;
            background-size: cover;
            border: 1px solid rgba(var(--v-theme-primary), 1);
            border-radius: inherit;
        }
    }

    .recognition-card__front {
        @apply tw-absolute tw-inset-0 tw-z-[3] tw-flex tw-flex-col tw-justify-end tw-p-8;

        img {
            @apply tw-absolute tw-inset-0 tw-z-[1] tw-h-full tw-w-full tw-object-cover;
        }

        p {
            @apply tw-relative tw-z-[2] tw-text-xl tw-font-semibold tw-text-white;
        }
    }

    .opacity_animation {
        @apply tw-transition-opacity tw-duration-300;

        &:hover {
            @apply tw-opacity-0;
        }
    }
</style>
